export const DEFAULT_THEME = {
  name: 'DEFAULT_THEME',
  dark: false,
  variables: {
    'border-color': '#e1e1e1',
    '--v-high-emphasis-opacity': '1',
  },
  colors: {
    black: '#121212',
    white: '#fff',
    primary: '#252525',
    navy: '#252525',
    green: '#03c76b',
    point: '#03c76b',
    success: '#1c95ff',
    blue: '#1c95ff',
    error: '#e95d77',
    orange: '#fa8823',
    red: '#e95d77',
    'body-light': '#83868A',
    'line-navy': '#e1e1e1',
    'bg-navy': '#f4f5fa',
    'bg-gray': '#F6F6F6',
    'bg-green': '#F5F9F7',
    standby: '#bbbbbb',
    'body-light-gray': '#bbbbbb',
    'line-gray': '#E1E1E1',
    'light-gray': '#e5e5e5',
    'bright-gray': '#f5f5f5',
    inputBorder: '#e1e1e1',
    'border-color': '#e1e1e1',
    surface: '#fff',
    background: '#fff',
    containerBg: '#f6f6f6',
    disable: '#e5e5e5',
    'on-surface-variant': '#fff',
    'on-green': '#fff',
    'on-surface': '#252525',
  },
};
